import type { RedirectRouteRelative } from '@/utilities/routers.ts'

import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeSlackCreate,
  detail: routeSlackDetail,
  home: routeSlackHome,
  root: routeSlackRoot,
} = createDoctypeRoutes({
  createName: 'new-slack',
  createPath: 'new-slack',
  detailName: 'slackDetail',
  doctype: DOCTYPES.SLACK_WEBHOOK_URL,
  homeName: 'slack',
  path: 'slack',
  views: {
    create: async () => await import('@/components/viewsExternal/slack/AddSlack.vue'),
    detail: async () => await import('@/components/viewsExternal/slack/ViewSlack.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/interfaces/ViewInterfaces.vue'),
  },
})

const redirectSlackDetail: RedirectRouteRelative = {
  name: routeSlackDetail.name,
}

export { redirectSlackDetail, routeSlackCreate, routeSlackDetail, routeSlackHome, routeSlackRoot }
